export const SINGLE_CHOICE = 1;
export const MULTI_CHOICE = 2;
export const MATCH_OPTIONS = 3;